// import 'babel-polyfill'
import { createApp, h } from "vue";
import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import App from "./App.vue";
import routers from "./router";
import store from "./store";
import "@/style/base.css";

// 引入按需加载element-plus
import installElementPlus from "./plugins/element-plus";
import routeMatch from "@/utils/route-match"; // 导入路由匹配文件路径函数
import { getCookie } from "@/utils/common";
import * as Types from "@/store/action-types";

let router = null;
const __qiankun__ = window.__POWERED_BY_QIANKUN__;
const openType = process.env.VUE_APP_OPEN_TYPE;
// const app = createApp(App).use(store).use(router)
// installElementPlus(app)
// app.mount('#app')
let app: any = createApp(App);
export async function bootstrap({
  data,
  utils,
  service,
  emitFnc,
  baseUrl,
}: any) {
  //挂载主应用下发的store
  app.config.globalProperties.$mainData = data;
  // 把工具函数挂载在vue $mainUtils对象
  app.config.globalProperties.$mainUtils = utils;
  app.config.globalProperties.$mainService = service;
  // 把mainEmit函数一一挂载
  Object.keys(emitFnc).forEach((i) => {
    app.config.globalProperties[i] = emitFnc[i];
  });
  app.config.globalProperties.$baseUrl = baseUrl;
  store.dispatch(`manageUser/${Types.SET_MANAGE_USER}`, data);
  // data.user.name = data.user.realName;
  // store.dispatch(`manageUser/${Types.SET_MANAGE_USER}`, data.user)
  // store.commit('app/SET_APP_LIST', data.appList);
}
export async function mount({ data = {}, ROUTES, routerBase }: any = {}) {
  console.log(JSON.stringify(routers));
  app.config.globalProperties.$routerBase = "/" + routerBase;
  router = createRouter({
    history:
      process.env.NODE_ENV === "development" && !window.__POWERED_BY_QIANKUN__
        ? createWebHashHistory(
            window.__POWERED_BY_QIANKUN__
              ? openType == "space"
                ? routerBase
                : "/" + routerBase
              : "/"
          )
        : createWebHistory(
            window.__POWERED_BY_QIANKUN__
              ? openType == "space"
                ? routerBase
                : "/" + routerBase
              : "/"
          ),
    routes: __qiankun__ ? routeMatch(ROUTES, routerBase) : routers,
  });
  app.use(store).use(router);
  installElementPlus(app);
  // installI18n(app)
  app.mount("#app");
  router.beforeEach((to, from, next) => {
    let userId = getCookie("userid");
    let enterpriseFullName = store.state.user.enterpriseFullName;
    if (userId) {
      if (!enterpriseFullName) {
        store
          .dispatch(`user/${Types.SET_USER_INFO}`, { userId: userId })
          .then((res) => {
            next();
          })
          .catch((err) => {
            console.log(err);
            document.cookie = "token=" + ";path=/";
            document.cookie = "userid=" + ";path=/";
            next("/");
          });
      } else {
        next();
      }
    } else {
      next();
    }
  });
}
export async function unmount() {
  app.unmount;
  app = null;
  router = null;
}

// 单独开发环境
__qiankun__ || mount();
